export enum EnumSubstituir {
    NAO = 0,
    SIM = 1,
}
